import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { lanesOptions } from '../data-provider/lanes';
import type { LanesParams } from '../models';

export const useGetLanes = (params: LanesParams) => useQuery(lanesOptions(params));
export const useSuspenseLanes = (params: LanesParams) => useSuspenseQuery(lanesOptions(params));
